var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTemplateActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Templates",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_850",
    "data-name": "Rectangle 850",
    width: 17,
    height: 17,
    transform: "translate(0 0)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "reader-outline_2_",
    "data-name": "reader-outline (2)",
    transform: "translate(3 2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_849",
    "data-name": "Rectangle 849",
    width: 11,
    height: 14,
    rx: 2,
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#1450ff",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1031",
    "data-name": "Path 1031",
    d: "M176,128h5.422M176,130.711h5.422M176,133.422h2.711",
    transform: "translate(-173.656 -125.623)",
    fill: "none",
    stroke: "#1450ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplateActive);
export default __webpack_public_path__ + "static/media/template_active.8d8e2521b45eaf124dd6e5a82acfa3e5.svg";
export { ForwardRef as ReactComponent };